/*
 * bpmbuild-production.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StripeSubscriptionBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./StripeSubscriptionBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildProductionappspotcom) {
      root.BpmbuildProductionappspotcom = {};
    }
    root.BpmbuildProductionappspotcom.StripeSubscriptionEventObject = factory(root.BpmbuildProductionappspotcom.ApiClient, root.BpmbuildProductionappspotcom.StripeSubscriptionBean);
  }
}(this, function(ApiClient, StripeSubscriptionBean) {
  'use strict';

  /**
   * The StripeSubscriptionEventObject model module.
   * @module model/StripeSubscriptionEventObject
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>StripeSubscriptionEventObject</code>.
   * @alias module:model/StripeSubscriptionEventObject
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>StripeSubscriptionEventObject</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StripeSubscriptionEventObject} obj Optional instance to populate.
   * @return {module:model/StripeSubscriptionEventObject} The populated <code>StripeSubscriptionEventObject</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('object'))
        obj._object = StripeSubscriptionBean.constructFromObject(data['object']);
    }
    return obj;
  }

  /**
   * @member {module:model/StripeSubscriptionBean} _object
   */
  exports.prototype._object = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsProduction/src/model/StripeSubscriptionEventObject.js